import { render, staticRenderFns } from "./AlterarMunicipio.vue?vue&type=template&id=0bbaadf4&scoped=true"
import script from "./AlterarMunicipio.vue?vue&type=script&lang=js"
export * from "./AlterarMunicipio.vue?vue&type=script&lang=js"
import style0 from "./AlterarMunicipio.vue?vue&type=style&index=0&id=0bbaadf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbaadf4",
  null
  
)

export default component.exports